import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom'
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.webp';
import FacebookIcon from '../Images/facebook-new.png';
import InstagramIcon from '../Images/instagram-icon.webp';
import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-10 col-md-10 col-sm-12 mx-auto">
                        <div className="row">
                            <div className="col-md-4 mt-3">
                                <h3 className="footer__headings">
                                    <b>Kaipsool Pharmatech</b>
                                </h3>
                                <div className="d-flex flex-column">
                                    <div className="footer__headingsContents">
                                        {/* <span className="footer__websiteAddress">Address:</span>&nbsp; */}
                                        Kaipsool Pharmatech not only serves as a pharmaceutical information platform but also lists sports tournaments, bridging the gap between the sports and health industries for greater synergy.
                                    </div>
                                    <span className="footer__websiteCopyright">© Copyrights 2021-25</span>
                                </div>
                            </div>
                            <div className="col-md-6 offset-md-2 mt-3">
                                <div className="row">
                                    <div className="col-md-6 footer__headingsContentMargin">
                                        <h4 className="footer__headings">Social Links</h4>
                                        <div className="d-flex flex-column">
                                            <div className="jobDetail__applyJobsShare">
                                                <div className="jobDetail__socialIcons">
                                                    <a href={`https://instagram.com/kaipsool?utm_source=qr&igshid=MThlNWY1MzQwNA==`} target="_blank"
                                                        style={{ marginRight: '12px' }}>
                                                        <Tooltip title="Share via instagram" placement="top">
                                                            <img src={InstagramIcon} alt="instagram-icon" width="32px" height="32px" />
                                                        </Tooltip>
                                                    </a>
                                                    <a href={`https://www.linkedin.com/company/kaipsool/`} target="_blank"
                                                        style={{ marginRight: '12px' }}>
                                                        <Tooltip title="Share via linkedIn" placement="top">
                                                            <img src={LinkedInIcon} alt="linkedin-icon" width="32px" height="32px" />
                                                        </Tooltip>
                                                    </a>
                                                    <a href={`https://www.facebook.com/kaipsool`} target="_blank"
                                                        style={{ marginRight: '12px' }}>
                                                        <Tooltip title="Share via facebook" placement="top">
                                                            <img src={FacebookIcon} alt="facebook-icon" width="40px" height="40px" />
                                                        </Tooltip>
                                                    </a>
                                                    {/* <a href={`https://twitter.com/`} target="_blank">
                                                        <Tooltip title="Share via twitter" placement="top">
                                                            <img src={TwitterIcon} alt="twitter-icon" width="36px" height="36px" />
                                                        </Tooltip>
                                                    </a> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 footer__headingsContentMargin Other__Links">
                                        <h4 className="footer__headings">Other Links</h4>
                                        <div className="d-flex flex-column">
                                            <Link to="/terms-conditions" target="_blank" rel="noopener noreferrer">
                                                <span className="footer__headingsContents">Terms & Conditions</span>
                                            </Link>
                                            <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                                <span className="footer__headingsContents">Privacy Policy</span>
                                            </Link>
                                            <Link to="/cancellation-refund" target="_blank" rel="noopener noreferrer">
                                                <span className="footer__headingsContents">Cancellation and Refund</span>
                                            </Link>
                                            <Link to="/shipping-delivery" target="_blank" rel="noopener noreferrer">
                                                <span className="footer__headingsContents">Shipping and Delivery</span>
                                            </Link>
                                            <Link to="/contact" target="_blank" rel="noopener noreferrer">
                                                <span className="footer__headingsContents">Contact Us</span>
                                            </Link>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-4 footer__headingsContentMargin">
                                        <h4 className="footer__headings">General</h4>
                                        <div className="d-flex flex-column">
                                            <span className="footer__headingsContents">Ict Products</span>
                                            <span className="footer__headingsContents">Functions</span>
                                            <span className="footer__headingsContents">Blogs</span>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
